import { createRouter, createWebHistory } from 'vue-router';
import {get_domain, get_sys_config } from '@/api/template'

// 导入其他路由组件

const routes = [
    { path: '/', name: '', component: null },
    // 其他路由配置
];


// 存储数据并设置时间
function setItemWithExpiration (key, value) {
    const now = new Date();
    const item = {
        value: value,
        expiry: now.getTime() + 24 * 60 * 60 * 1000
    };
    localStorage.setItem(key, JSON.stringify(item));
}

// 获取 localStorage 中的数据，并检查是否过期
function getItemWithExpiration (key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
        return null;
    }
    try {
        const item = JSON.parse(itemStr);
        const now = new Date().getTime();
        // 如果当前时间超过了数据的过期时间，移除数据并返回 null
        if (now > item.expiry) {
            localStorage.removeItem(key);
            return null;
        }
        return item.value;
    } catch (error) {
        console.error('Error parsing localStorage item:', error);
        return null;
    }
}

function getUrl () {
    let queryString = window.location.search;
    // 去掉开头的 '?'
    if(queryString) {
        let value = queryString.substring(1);
        return value
    } else {
        return false
    }
    
}


export async function setupRouter(app) {
    let modifiedRoutes = []
    let templateData = await getItemWithExpiration('templateData') 
    
    if(templateData && templateData.api_cache === 1) {
        modifiedRoutes = routes.map(route => {
            return {
                path: '/',
                name: templateData.path,
                // component: () => import(`@/views/template10/template10.vue`)
                component: () => import(`@/views/${templateData.path}/${templateData.path}.vue`)
            }
        });
    } else {
        let url = getUrl()
        if(url) {
            // 获取域名数据
            let data = {
                // id: 138,
                code: url,
            }
            const res = await get_domain(data);
           
            if(res.data.path && res.data.path != '') {
                // 缓存24小时
                setItemWithExpiration('templateData', res.data)      

                // 根据域名数据修改路由配置                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           mmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn
                modifiedRoutes = routes.map(route => {
                    return {
                        path: '/',
                        name: res.path,
                        // component: () => import(`@/views/template10/template10.vue`)
                        component: () => import(`@/views/${res.data.path}/${res.data.path}.vue`)
                    }
                });
            } else {
                // 不为200 跳转美403页面
                // modifiedRoutes = routes.map(route => {
                //     return {
                //         path: '/',
                //         name: '403',
                //         component: () => import(`@/views/404/404.vue`)
                //     }
                // });

                modifiedRoutes = routes.map(route => {
                    return {
                        path: '/',
                        name: '403',
                        component: () => import(`@/views/404/404.vue`)
                    }
                });
            }
        } else {
            modifiedRoutes = routes.map(route => {
                return {
                    path: '/',
                    name: '403',
                    component: () => import(`@/views/404/404.vue`)
                }
            });
        }
        
    }

    const routesArr = await Promise.all(modifiedRoutes);

    // 创建路由实例
    const router = createRouter({
        history: createWebHistory(),
        routes: routesArr
    });

    // 使用路由
    app.use(router);
}

